import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { MODULES } from "@/lib/modules";
import { useLang } from "@/context/LangContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Lock, ArrowLeft, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ComingSoon() {
  const { id } = useParams();
  const { lang, t } = useLang();
  const m = MODULES.find((x) => x.id === id);
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const info = m ? m[lang] : { name: "Module", desc: "" };
  const Icon = m?.icon || Lock;

  const join = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/waitlist", { module: id, email });
      setDone(true);
      toast.success("You're on the waitlist");
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#050A15]">
      <Header />
      <div className="mx-auto max-w-3xl px-6 py-16">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-[#00FFFF] mb-8"><ArrowLeft className="h-4 w-4" /> All modules</Link>

        <div className="qs-grad-border p-10 text-center qs-noise">
          <span className="inline-grid place-items-center h-16 w-16 rounded-sm mx-auto" style={{ background: "#8A2BE21A" }}>
            <Icon className="h-8 w-8 text-[#8A2BE2]" />
          </span>
          <span className="block mt-5 text-xs font-mono uppercase tracking-widest text-slate-500">{t("soon")}</span>
          <h1 className="font-display font-extrabold text-3xl md:text-4xl mt-3">{info.name}</h1>
          <p className="text-slate-400 mt-4 max-w-xl mx-auto leading-relaxed">{info.desc}</p>

          {done ? (
            <div className="mt-8 flex items-center justify-center gap-2 text-[#00FF7F]" data-testid="waitlist-done">
              <CheckCircle2 className="h-5 w-5" /> You'll be first to know when this launches.
            </div>
          ) : (
            <form onSubmit={join} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-testid="waitlist-form">
              <input data-testid="waitlist-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="flex-1 bg-[#050A15] border border-white/10 px-4 py-3 outline-none focus:border-[#8A2BE2]" />
              <button data-testid="waitlist-submit" disabled={loading}
                className="qs-cta bg-[#8A2BE2] text-white font-semibold px-6 py-3 flex items-center justify-center gap-2 disabled:opacity-60">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Join Waitlist"}
              </button>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
